module.exports = "<div *ngIf=\"showError\" class=\"alert alert-dismissible alert-primary\">\n  <strong>{{ textError | uppercase }}</strong>\n</div>\n"